/* import __COLOCATED_TEMPLATE__ from './market-input-phone.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { schedule, next } from '@ember/runloop';
import environment from '@square/environment-utils/environment';
import { isEmpty } from '@ember/utils';
const MAX_PHONE_NUMBER_LENGTH = 20;
let MarketInputPhone = (_dec = service('formatter'), _class = class MarketInputPhone extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "formatterService", _descriptor2, this);
    // internal
    _defineProperty(this, "focused", false);
    _defineProperty(this, "input", null);
    _defineProperty(this, "maxPhoneNumberLength", MAX_PHONE_NUMBER_LENGTH);
  }
  get displayValue() {
    return this.format(this.args.value);
  }
  format(phoneNumber) {
    const parsedNumber = this.removeFormatting(phoneNumber);
    return this.formatterService.getPhoneNumberFormatter().format(parsedNumber);
  }
  removeFormatting(formattedPhoneNumber) {
    if (isEmpty(formattedPhoneNumber)) {
      return formattedPhoneNumber;
    }
    return formattedPhoneNumber.replace(/\D/g, '');
  }
  inputEventListener() {
    const inputElement = this.input;
    const inputValue = inputElement.value;
    const cursorPosition = inputElement.selectionStart;
    const formattedValue = this.format(inputValue);

    // if the cursorPosition isn't at the end of the line then we don't want it to jump to the end
    //  so we pass in the cursorPosition to the update function
    if (cursorPosition !== inputValue.length) {
      this.updateAndRenderValue({
        inputElement,
        formattedValue,
        cursorPosition
      });
    }
    this.updateAndRenderValue({
      inputElement,
      formattedValue
    });
  }
  keyDownEventListener(e) {
    const inputElement = this.input;
    const inputValue = inputElement.value;
    const cursorPosition = inputElement.selectionStart;
    if (e.key === 'Backspace' && (inputValue[cursorPosition - 1] === '-' || inputValue[cursorPosition - 1] === ' ' || inputValue[cursorPosition - 1] === ')' || inputValue[cursorPosition - 1] === '(')) {
      e.preventDefault();
      const cursorPositionWithoutDeletedChars = cursorPosition - 2;
      const inputValueWithoutDeletedChars = inputValue.slice(0, cursorPositionWithoutDeletedChars) + inputValue.slice(cursorPosition);

      // Re-format the value and find the new cursor position.
      const formattedValue = this.format(inputValueWithoutDeletedChars);
      this.updateAndRenderValue({
        inputElement,
        formattedValue,
        cursorPosition
      });
    }
    if (e.key === 'Delete' && (inputValue[cursorPosition] === '-' || inputValue[cursorPosition] === ' ' || inputValue[cursorPosition] === ')' || inputValue[cursorPosition] === '(')) {
      e.preventDefault();
      const inputValueWithoutDeletedChars = inputValue.slice(0, cursorPosition) + inputValue.slice(cursorPosition + 2);

      // Re-format the value and find the new cursor position.
      const formattedValue = this.format(inputValueWithoutDeletedChars);
      this.input.setSelectionRange(cursorPosition, cursorPosition);
      // We've modified the value by deleting a digit. Update visible and internal state.
      this.updateAndRenderValue({
        inputElement,
        formattedValue,
        cursorPosition
      });
    }
  }
  updateAndRenderValue({
    inputElement,
    formattedValue,
    cursorPosition
  }) {
    this.input.value = formattedValue;
    this.args.onChange?.(this.removeFormatting(formattedValue));
    if (cursorPosition) {
      if (environment().isTesting) {
        // Tests require us to defer this work to a future runloop, otherwise the cursor
        // is set to the end of the input _after_ we do this.
        next(this, () => {
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      } else {
        schedule('afterRender', this, () => {
          inputElement.setSelectionRange(cursorPosition, cursorPosition);
        });
      }
    }
  }
  async didInsert(marketInput) {
    this.input = await marketInput.getInputElement();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formatterService", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype), _class);
export { MarketInputPhone as default };